
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/library/reader/[id]",
      function () {
        return require("private-next-pages/library/reader/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/library/reader/[id]"])
      });
    }
  